


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { formatNum, genConfig } from '../../render';
import { IConfigV2, ITimeParsed, ITimeType } from '../../types';
import { IActions, IStats, ISaveConfigParams } from '@/store/home/stats/types';
import HomeWidgetCard from '@/views/home/common/Card.vue';
import LoginThreshChart from './LoginThreshChart.vue';
import LoginThreshTable from './LoginThreshTable.vue';

const Stats = namespace('home/stats');

// 用户异常登录统计
@Component({
  components: { HomeWidgetCard, LoginThreshChart, LoginThreshTable },
})
export default class LoginThresh extends Vue {
  @Stats.Action('queryLoginThreshStats') public queryStats!: IActions['queryLoginThreshStats'];
  @Stats.State('loginThreshStats') public stats!: IStats;

  @Stats.Action('queryLoginThreshList') public queryList!: IActions['queryLoginThreshList'];
  @Stats.Action('saveWidgetConfig') public saveConfig!: IActions['saveWidgetConfig'];

  @Prop() public code!: string;
  @Prop() public title!: string;
  @Prop() public userId!: number;
  @Prop() public configId!: number;
  @Prop() public config!: IConfigV2;

  public expanded = false;

  public get colNum() {
    return this.config?.cols || 6;
  }

  // 保存接口入参
  public get saveParams() {
    const widgetCode = this.code;
    const config = JSON.stringify(genConfig({ ...this.config, period: 'today' }));
    const baseConfig = this.configId ? { widgetCode, configId: this.configId } : { widgetCode };
    const needSave = !!this.userId && !!widgetCode && (this.config.period !== 'today');
    return needSave ? { userId: this.userId, configs: [{ ...baseConfig, config }] } : null;
  }

  // 统计数据
  public get items() {
    const data = this.stats.data;
    const totalCount = data[0]?.aggNum || 0;
    return [{ text: '异常登录总人数', value: formatNum(totalCount) }];
  }

  // 时间变化时触发(初始化会触发)
  public onTimeChange(period: ITimeType, parsedTime: ITimeParsed) {
    const params = { startTime: parsedTime.startTime, endTime: parsedTime.overTime };
    this.queryStats(params);
    if (this.expanded) {
      this.queryList(params);
    }
  }

  // 展开或收起
  public onExpandPanel(expanded: boolean, parsedTime: ITimeParsed) {
    this.expanded = expanded;
    if (expanded) {
      this.queryList({ startTime: parsedTime.startTime, endTime: parsedTime.overTime });
    }
  }

  // 如果初始配置里`period`不是'today', 则自动保存一次
  @Watch('saveParams', { immediate: true })
  public watchSaveParams(value: ISaveConfigParams) {
    if (value) {
      this.saveConfig(value);
    }
  }
}
